<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="tipos"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
